export const studentIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The Student Summary is where you can view each student\'s usage and progress, and performance data all in one location. This report can be shared with the student and/or their family.'
  },
  {
    element: '#student-dropdown',
    intro: 'Select a student from the dropdown to view their specific data.'
  },
  {
    element: '#hideSharedStudentsCheckBox',
    intro: 'Select this box to hide students who have been shared with you. Once enabled, the student list above will only display those you are directly assigned to — excluding any students you\'re listed as a co-teacher for.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Student Summary for the selected student.'
  },
  {
    element: '#student-usage-progress-wrapper',
    intro: 'See the student\'s usage and progress. This includes their current unit and level, their weekly minutes and levels completed for the current week, and their average weekly usage minutes.'
  },
  {
    element: '#student-performance-wrapper',
    intro: 'See the student\'s performance data. This includes Screener, Diagnostic, and Objective Assessment results.'
  },
  {
    element: '#screenerResults',
    intro: 'The WordFlight Screener helps predict how a student may perform on the Diagnostic and whether WordFlight is a good fit for them. Results include a score range, risk category, and test date. The goal is for students to grow toward the green Proficiency range.'
  },
  {
    element: '#diagnosticResults',
    intro: 'Students take Diagnostics before Unit 1, after Unit 12, and after Unit 24. Students in grades 5+ receive both Automatic Word Recognition and Decoding scores. Students in grades 2–4 receive a Word Recognition score. The goal is continued growth toward strong, automatic word recognition skills.'
  },
  {
    element: '#objectiveResults',
    intro: 'Students take a short pretest before each of the six learning Objectives. Students then practice skills each day to build growth and confidence in decoding, syllable knowledge and word recognition. After students complete four Units in the learning objective, they take the short post test.'
  },
  {
    element: '#diagnostic-button',
    intro: 'Click here to view the student\'s Student Diagnostic Results report.'
  },
  {
    element: '#assessments-button',
    intro: 'Click here to view the student\'s Objective Pre/Post report.'
  }
];
